import { render, staticRenderFns } from "./dds.vue?vue&type=template&id=c4b2b2b6&scoped=true&"
import script from "./dds.vue?vue&type=script&lang=js&"
export * from "./dds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b2b2b6",
  null
  
)

export default component.exports